import React, { useState, useContext, useEffect, useRef } from "react";
import Button from "@mui/material/Button";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import CloseIcon from "@mui/icons-material/Close";
import {
  DialogContent,
  IconButton,
  Stack,
  TableContainer,
  Tooltip,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import axios from "axios";
import AuthContext from "../context/userAuth.context";
import DeleteIcon from "@mui/icons-material/Delete";
import { red } from "@mui/material/colors";

function AgencyPanel(props) {
  const ImageUploderRef = useRef(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [allUserPages, setAllUserPages] = useState([]);
  const [agencyURL, setAgencyURL] = useState(null);
  const [Logo, setLogo] = useState(
    "https://app.toons.ai/animatricksAPI/DefaultAgencyLogo.png"
  );
  const [previewLogo, setpreviewLogo] = useState(
    "https://app.toons.ai/animatricksAPI/DefaultAgencyLogo.png"
  );
  let authData = JSON.parse(
    localStorage.getItem("animation_studio_2.0_access_token")
  );

  const imageUpload = () => {
    ImageUploderRef.current.click();
  };

  const onSelectFile = async (e) => {
    const objectUrl = URL.createObjectURL(e.target.files[0]);
    const imgBlob = await fetch(objectUrl).then((r) => r.blob());
    var reader = new FileReader();
    reader.readAsDataURL(imgBlob);
    reader.onloadend = function () {
      var base64data = reader.result;

      UpdateLogoInAgencyPage(base64data);
    };
  };

  const UpdateLogoInAgencyPage = (base64data) => {
    //will call api here
    let formdata = new FormData();
    formdata.append("logoImage", base64data);
    formdata.append("agencyUserId", user_id);
    axios
      .post(
        authenticationData.ApiBaseURL + "/api/Account/uploadAgencyUserLogo",
        formdata,
        {
          headers: {
            "Content-Type": `multipart/form-data`,
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          alert("Logo uploaded successfully");
          setLogo(base64data);
          setpreviewLogo(base64data);
        } else {
          alert("Logo upload failed.");
        }
      });
  };

  const { authenticationData, Role } = useContext(AuthContext);

  let user_id = JSON.parse(
    localStorage.getItem("animation_studio_2.0_access_token")
  ).User_Id;

  useEffect(() => {
    GetAllAgencySubUser();
    setAgencyURL(
      "https://videopreview.net/index.html?agencyuserId=" + user_id + ""
    );
    GetAgencyUserLogo(user_id);
  }, []);

  const GetAgencyUserLogo = (user_id) => {
    let formdata = new FormData();
    formdata.append("agencyUserId", user_id);
    axios
      .post(
        authenticationData.ApiBaseURL + "/api/Account/getAgencyUserLogo",
        formdata,
        {
          headers: {
            "Content-Type": `multipart/form-data`,
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((res) => {
        if (res.data && res.data.status && res.data.result.length > 0) {
          setLogo(res.data.result[0].logoImage);
          setpreviewLogo(res.data.result[0].logoImage);
        }
      });
  };

  const GetAllAgencySubUser = () => {
    axios
      .get(authenticationData.ApiBaseURL + "/api/Account/GetAllAgencySubUser", {
        headers: {
          "Content-Type": `multipart/form-data`,
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + authData.access_token,
        },
      })
      .then((res) => {
        setAllUserPages(res.data.allAgencySubUser);
      });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    setEmailError(false);
    setPasswordError(false);

    if (email == "") {
      setEmailError(true);
    }
    if (password == "") {
      setPasswordError(true);
    }
    if (name == "") {
      setPasswordError(true);
    }

    if (email && password && name) {
      if (allUserPages.find((x) => x.email == email)) {
        alert("Sub User already Exists");
        return;
      }
      let formdata = new FormData();

      formdata.append("email", email);
      formdata.append("password", password);
      formdata.append("name", name);
      setsaveMessage(false);
      setlimitExceeded(false);
      axios
        .post(
          authenticationData.ApiBaseURL + "/api/Account/SaveAgencySubUser",
          formdata,
          {
            headers: {
              "Content-Type": `multipart/form-data`,
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((res) => {
          if (res.data.status == "Agency Sub User saved Successfully") {
            setsaveMessage(true);
          } else if (res.data.status == "Agency Sub Users Limit Exceeded..") {
            setlimitExceeded(true);
          }
          GetAllAgencySubUser();
        });
    }
  };

  const deleteSubUser = (id) => {
    let formdata = new FormData();
    formdata.append("subUserid", id);
    axios
      .post(
        authenticationData.ApiBaseURL + "/api/Account/DeleteAgencySubUser",
        formdata,
        {
          headers: {
            "Content-Type": `multipart/form-data`,
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((res) => {
        GetAllAgencySubUser();
      });
  };
  const [limitExceeded, setlimitExceeded] = useState(false);
  const [saveMessage, setsaveMessage] = useState(false);
  return (
    <>
      <div className="mt-3 createUpper">
        <React.Fragment>
          <form autoComplete="off" onSubmit={handleSubmit}>
            <TextField
              label="Agency showcase Page"
              disabled
              variant="outlined"
              color="secondary"
              sx={{ mb: 3 }}
              fullWidth
              value={agencyURL}
              error={passwordError}
            />

            <Button
              color="secondary"
              onClick={(e) => {
                imageUpload();
              }}
              startIcon={<FileUploadIcon />}
              align="right"
              sx={{
                mt: 2,
                mb: 2,
                textTransform: "none",
              }}
              variant="contained"
              disableElevation
            >
              Upload Logo
            </Button>
            <input
              ref={ImageUploderRef}
              hidden
              type="file"
              accept="image/png, image/jpeg"
              onChange={onSelectFile}
            ></input>
            {Logo && (
              <>
                <img
                  style={{
                    height: "30px",
                    marginLeft: "12px",
                    marginRight: "0px",
                    marginTop: "0px",
                  }}
                  src={previewLogo}
                ></img>
              </>
            )}

            <h1 style={{ color: "#286aff", marginTop: "2rem" }}>
              Add Agency Sub-Users
            </h1>
            <TextField
              label="Name"
              onChange={(e) => {
                setName(e.target.value);
                setlimitExceeded(false);
                setsaveMessage(false);
              }}
              required
              variant="outlined"
              color="secondary"
              sx={{ mb: 3 }}
              fullWidth
              value={name}
              error={passwordError}
            />
            <TextField
              label="Email"
              onChange={(e) => {
                setEmail(e.target.value);
                setlimitExceeded(false);
                setsaveMessage(false);
              }}
              required
              variant="outlined"
              color="secondary"
              type="email"
              sx={{ mb: 3 }}
              fullWidth
              value={email}
              error={emailError}
            />
            <TextField
              label="Password"
              onChange={(e) => {
                setPassword(e.target.value);
                setlimitExceeded(false);
                setsaveMessage(false);
              }}
              required
              variant="outlined"
              color="secondary"
              type="password"
              value={password}
              error={passwordError}
              fullWidth
              sx={{ mb: 3 }}
            />
            <Button variant="outlined" color="secondary" type="submit">
              Add User
            </Button>
            {limitExceeded && (
              <div className="mt-2" style={{ color: "#db2727" }}>
                Agency sub-user limit exceeded.
              </div>
            )}
            {saveMessage && (
              <div style={{ color: "#56ad18" }} className="mt-2">
                Agency sub-user saved successfully.
              </div>
            )}

            <DialogContent>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <strong>Id</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Name</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Email</strong>
                      </TableCell>
                      <TableCell>
                        <strong>Password</strong>
                      </TableCell>
                      <TableCell align="right">
                        <strong>Actions</strong>
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {allUserPages.length > 0 &&
                      allUserPages.map((item, i) => {
                        return (
                          <TableRow>
                            <TableCell>{item.id}</TableCell>
                            <TableCell>{item.name}</TableCell>
                            <TableCell>{item.email}</TableCell>
                            <TableCell>{item.password}</TableCell>
                            <TableCell align="right">
                              <Stack
                                justifyContent="flex-end"
                                direction="row"
                                spacing={2}
                              >
                                <Tooltip title="Delete">
                                  <IconButton
                                    onClick={(e) => {
                                      deleteSubUser(item.id);
                                    }}
                                  >
                                    <DeleteIcon sx={{ color: red[500] }} />
                                  </IconButton>
                                </Tooltip>
                              </Stack>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            </DialogContent>
          </form>
        </React.Fragment>
      </div>
    </>
  );
}

export default AgencyPanel;
